import { Modal } from './Modal';

export interface ConfirmModalProps {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary';
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  loading,
  onConfirm,
  onClose,
}: ConfirmModalProps) {
  const confirmClass =
    variant === 'danger'
      ? 'bg-danger-600 text-white hover:bg-danger-700'
      : 'bg-dash-primary text-white hover:opacity-90';

  return (
    <Modal open={open} onClose={onClose} size="md" footer={null}>
      <h3 className="text-lg font-semibold text-dash-on-surface">{title}</h3>
      {description && (
        <p className="mt-2 break-words text-sm leading-relaxed text-dash-on-surface-variant">{description}</p>
      )}
      <div className="mt-6 flex flex-wrap items-center justify-end gap-3">
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="inline-flex shrink-0 items-center justify-center rounded-lg border border-dash-outline-variant bg-secondary-200 px-4 py-2.5 text-sm font-medium text-dash-on-surface-variant transition-colors hover:bg-secondary-300 disabled:opacity-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className={`inline-flex shrink-0 items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-medium transition-opacity disabled:opacity-50 ${confirmClass}`}
        >
          {loading && (
            <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
          )}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
